import React from 'react';
interface MenuItem {
  title: string;
  url: string;
  children?: {
    title: string;
    url: string;
  }[];
}
// Self-contained desktop menu definition.
// Summer Camp is intentionally omitted here — it is shown as a separate pill.
const menuItems: MenuItem[] = [{
  title: 'Classes & Programs',
  url: '/programs',
  children: [{
    title: 'All Classes & Programs',
    url: '/programs'
  }, {
    title: 'Mini Troopers (Ages 3–5)',
    url: '/mini-troopers'
  }, {
    title: 'Kids Classes',
    url: '/karate-kids-classes.html'
  }, {
    title: 'Adult Classes',
    url: '/karate-adult-classes'
  }, {
    title: 'Family Martial Arts',
    url: '/family-martial-arts-classes'
  }, {
    title: 'Self-Defense',
    url: '/self-defense-classes-in-farmington-hills-michigan'
  }, {
    title: 'Competition Team',
    url: '/competition-team'
  }, {
    title: 'Summer Camp',
    url: '/summer-camp'
  }]
}, {
  title: 'Reviews',
  url: '/reviews'
}, {
  title: 'Coaches',
  url: '/coaches'
}, {
  title: 'Schedule',
  url: '/schedule'
}, {
  title: 'Contact',
  url: '/contact'
}];
export function DesktopMenu() {
  return <nav className="hidden lg:flex items-center gap-5 xl:gap-7" data-id="element-297">
      {menuItems.map(item => item.children && item.children.length > 0 ? <div key={item.title} className="relative group" data-id="element-298">
            {item.url ? <a href={item.url} className="flex items-center gap-1 text-sm font-bold text-ink hover:text-storm-red transition-colors uppercase tracking-wide whitespace-nowrap py-2 focus:outline-none focus-visible:text-storm-red" aria-haspopup="true" data-id="element-299">
                {item.title}
                <svg className="w-4 h-4 transition-transform group-hover:rotate-180 group-focus-within:rotate-180" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-300">
                  <path d="m6 9 6 6 6-6" data-id="element-301" />
                </svg>
              </a> : <button type="button" className="flex items-center gap-1 text-sm font-bold text-ink hover:text-storm-red transition-colors uppercase tracking-wide whitespace-nowrap py-2 focus:outline-none focus-visible:text-storm-red" aria-haspopup="true" data-id="element-302">
                {item.title}
                <svg className="w-4 h-4 transition-transform group-hover:rotate-180 group-focus-within:rotate-180" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-303">
                  <path d="m6 9 6 6 6-6" data-id="element-304" />
                </svg>
              </button>}

            {/* Dropdown */}
            <div className="absolute left-0 top-full pt-2 w-64 opacity-0 invisible translate-y-1 group-hover:opacity-100 group-hover:visible group-hover:translate-y-0 group-focus-within:opacity-100 group-focus-within:visible group-focus-within:translate-y-0 transition-all duration-150 z-50" data-id="element-305">
              <ul className="bg-paper border border-subtle-gray rounded-2xl shadow-xl py-2 overflow-hidden" role="menu" aria-label={item.title} data-id="element-306">
                {item.children.map(child => <li key={child.title} role="none" data-id="element-307">
                    <a href={child.url} role="menuitem" className="block px-5 py-2.5 text-sm font-medium text-ink hover:bg-storm-red/5 hover:text-storm-red transition-colors" data-id="element-308">
                      {child.title}
                    </a>
                  </li>)}
              </ul>
            </div>
          </div> : <a key={item.title} href={item.url} className="text-sm font-bold text-ink hover:text-storm-red transition-colors uppercase tracking-wide whitespace-nowrap" data-id="element-309">
            {item.title}
          </a>)}
    </nav>;
}